export class ConfirmUserModel {
  userid: string;
  code: string;

  constructor(userid: string,
              code: string) {
    this.userid = userid;
    this.code= code;

  }
}
